import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Layout } from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Kasir from "@/pages/Kasir";
import Produk from "@/pages/Produk";
import Riwayat from "@/pages/Riwayat";
import Laporan from "@/pages/Laporan";
import Pengaturan from "@/pages/Pengaturan";
import KelolaUser from "@/pages/KelolaUser";
import Menu from "@/pages/Menu";
import { AuthCallback } from "@/components/AuthCallback";
import { MANAGERS, ALL_ROLES, homeFor, can } from "@/lib/roles";

const Protected = ({ children }) => {
  const { user } = useAuth();
  const location = useLocation();
  if (user === null)
    return <div className="flex h-screen items-center justify-center text-slate-500" data-testid="auth-loading">Memuat...</div>;
  if (!user) return <Navigate to="/login" replace state={{ from: location }} />;
  return children;
};

const Allow = ({ roles, children }) => {
  const { user } = useAuth();
  return can(user, roles) ? children : <Navigate to={homeFor(user?.role)} replace />;
};

const AppRoutes = () => {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/menu" element={<Menu />} />
            <Route element={<Protected><Layout /></Protected>}>
              <Route path="/" element={<Allow roles={MANAGERS}><Dashboard /></Allow>} />
              <Route path="/kasir" element={<Allow roles={ALL_ROLES}><Kasir /></Allow>} />
              <Route path="/produk" element={<Allow roles={MANAGERS}><Produk /></Allow>} />
              <Route path="/riwayat" element={<Allow roles={ALL_ROLES}><Riwayat /></Allow>} />
              <Route path="/laporan" element={<Allow roles={MANAGERS}><Laporan /></Allow>} />
              <Route path="/pengaturan" element={<Allow roles={MANAGERS}><Pengaturan /></Allow>} />
              <Route path="/users" element={<Allow roles={["owner"]}><KelolaUser /></Allow>} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
  );
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
